import { render, staticRenderFns } from "./Contributions.vue?vue&type=template&id=4e389128&scoped=true&"
import script from "./Contributions.vue?vue&type=script&lang=js&"
export * from "./Contributions.vue?vue&type=script&lang=js&"
import style0 from "./Contributions.vue?vue&type=style&index=0&id=4e389128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e389128",
  null
  
)

export default component.exports